{
  "name": "eemo-frontend",
  "version": "1.26.0-SNAPSHOT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-backend": "ng serve --proxy-config proxy-backend.conf.json",
    "start-backend-agent": "ng serve --proxy-config proxy-backend-agent.conf.json",
    "start-nlas": "ng serve --host 0.0.0.0 --allowed-hosts mpdn.local",
    "start-fab": "ng serve --host 0.0.0.0 --public-host mac-fab.local --proxy-config proxy-local.conf.json",
    "build": "ng build",
    "build-prod-old": "ng --max_old_space_size=2048 build --configuration=production",
    "build-dev-old": "ng --max_old_space_size=2048 build --configuration=development",
    "build-prod": "node --max_old_space_size=2048 ./node_modules/@angular/cli/bin/ng build --configuration=production",
    "build-dev": "node --max_old_space_size=2048 ./node_modules/@angular/cli/bin/ng build --configuration=development",
    "post-build": "node ./post-build.js",
    "test": "ng test",
    "test:ci": "ng test --watch=false --browsers=ChromeHeadless",
    "lint": "ng lint",
    "e2e": "ng e2e --config-file cypress/environments/cypress.config.prod.ts",
    "e2e-dev": "ng e2e --config-file cypress/environments/cypress.config.dev.ts",
    "e2e-local": "cypress run --config-file cypress/environments/cypress.config.local.ts",
    "debug": "node --nolazy --inspect-brk=9229 ",
    "sw": "ng-swagger-gen --config ng-swagger-gen-geo.json",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "prepare": "cd .. && husky web/.husky"
  },
  "private": true,
  "engines": {
    "node": ">=22.12.0"
  },
  "dependencies": {
    "@angular/animations": "^20.3.34",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.34",
    "@angular/compiler": "^20.3.34",
    "@angular/core": "^20.3.34",
    "@angular/elements": "^20.3.34",
    "@angular/forms": "^20.3.34",
    "@angular/material": "^20.2.14",
    "@angular/material-moment-adapter": "^20.2.14",
    "@angular/platform-browser": "^20.3.34",
    "@angular/platform-browser-dynamic": "^20.3.34",
    "@angular/router": "^20.3.34",
    "@auth0/angular-jwt": "~5.2.0",
    "@eemo/api-client": "^1.26.0-SNAPSHOT.202611022311",
    "@fortawesome/fontawesome-free": "~6.5.1",
    "@helpscout/javascript-sdk": "^0.8.0",
    "@mapbox/vector-tile": "^1.3.1",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@swimlane/ngx-charts": "^20.5.0",
    "angular-google-charts": "~16.1.0",
    "leaflet": "^1.9.4",
    "leaflet-providers": "~2.0.0",
    "leaflet-vector-tile-layer": "^0.16.0",
    "leaflet.icon.glyph": "~0.3.0",
    "leaflet.locatecontrol": "~0.79.0",
    "leaflet.markercluster": "~1.5.3",
    "mdb-angular-ui-kit": "^9.1.0",
    "moment": "^2.30.1",
    "ng-recaptcha-2": "^16.0.1",
    "ng2-pdfjs-viewer": "^20.0.1",
    "ngx-cookie-service": "^20.1.1",
    "ngx-device-detector": "^10.1.0",
    "pbf": "^3.2.1",
    "rxjs": "~7.8.1",
    "swiper": "^12.2.0",
    "tslib": "^2.6.2",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular/build": "^20.3.41",
    "@angular/cli": "^20.3.41",
    "@angular/compiler-cli": "^20.3.34",
    "@angular/language-service": "^20.3.34",
    "@babel/compat-data": "~7.23.5",
    "@cypress/schematic": "^2.5.2",
    "@eslint/js": "^9.39.5",
    "@types/geojson": "7946.0.13",
    "@types/jasmine": "^5.1.4",
    "@types/leaflet": "~1.9.0",
    "@types/leaflet-providers": "~1.2.1",
    "@types/leaflet.icon.glyph": "~0.2.1",
    "@types/leaflet.locatecontrol": "~0.74.4",
    "@types/leaflet.markercluster": "~1.5.1",
    "@types/node": "^20.10.4",
    "angular-eslint": "^20.7.0",
    "cypress": "~16.2.0",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^10.1.8",
    "husky": "^9.1.7",
    "jasmine-core": "~5.1.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.1",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "^17.5.1",
    "prettier": "3.9.7",
    "ts-node": "~10.9.1",
    "typescript": "~5.8.3",
    "typescript-eslint": "^8.70.0"
  },
  "lint-staged": {
    "*.{ts,js,mjs,cjs,html,scss,css,json,md}": "prettier --write"
  },
  "overrides": {
    "piscina": "^5.3.2",
    "tar": "^7.5.22",
    "postcss": "^8.5.31",
    "rollup": "^4.65.0",
    "webpack-dev-middleware": "^7.4.6",
    "picomatch@^4": "^4.0.7",
    "tmp": "^0.2.7",
    "@eemo/api-client": {
      "@angular/core": "$@angular/core"
    }
  }
}
